import React, {useState, useEffect, useMemo}					from 'react';
import {useNavigate, useParams}						from 'react-router-dom';
import moment										from 'moment';

import DevicesCharacteristicForm					from './DevicesCharacteristicForm';
import DevicesImport								from './DevicesImport';
import DeviceDocuments 								from './DevicesDocuments';
import Button										from '../ressources/components/Button';
import Input										from '../ressources/components/Input';
import MultiInputContainer							from '../ressources/components/Input/MultiInputContainer';
import Tabs											from '../ressources/components/Tabs';
import Select										from '../ressources/components/Select';
import Icon											from '../ressources/components/Icon';
import {DeviceCard}									from '../ressources/components/Device';
import Modal										from '../ressources/components/Modal';
import {IconModalSave}								from '../ressources/components/Icon/preConfig';
import AddCard										from '../ressources/components/AddCard';
import ButtonStickyContainer						from '../ressources/components/Button/ButtonStickyContainer';
import ModalAssign									from '../ressources/components/ModalAssign';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {postDevicesApi}								from '../redux/devices/devices';
import {pushUpload, setUploadPercent}				from '../redux/documents/documents';
import {PutDeviceData}								from '../redux/devices/interface';
import {InputValues}								from '../ressources/components/Input/interface';
import {SelectData, SelectValues}					from '../ressources/components/Select/interface';

import {ft_formatPrice}								from '../ressources/functions/format';
import {ft_genNotification, ft_pushNotification} 	from '../ressources/functions/notification';

import img_backgroundAddManually					from '../ressources/images/background/addDeviceManually.jpg';
import img_backgroundAddImport						from '../ressources/images/background/addDeviceImport.jpg';
import img_computer									from '../ressources/images/icon/devices/computer.svg';
import img_fileDownload								from '../ressources/images/icon/file-download.svg';
import img_upload									from '../ressources/images/icon/upload.svg';

import LANGUAGE										from '../ressources/language';
import * as API										from '../ressources/API';
import {LOCATION_TYPE, DEVICE_TYPE}					from '../ressources/data/form';

import './Devices.css';


let TIMEOUT: ReturnType<typeof setTimeout>;

function DeviceAdd() {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const lang = useAppSelector(state => state.settings.lang);
	const devices = useAppSelector(state => state.devices.data);
	const mobileLines = useAppSelector(state => state.mobileLines.data);
	const documentsUpload = useAppSelector(state => state.documents.uploadDocument);
	let notificationId = useAppSelector(state => state.notifications.lastId);

	const [view, set_view] = useState('home');
	const [step, set_step] = useState<number>(1);

	const [name, set_name] = useState<InputValues>('');
	const [state, set_state] = useState<SelectValues>(null);
	const [purchaseType, set_purchaseType] = useState<SelectValues>(null);
	const [deviceType, set_deviceType] = useState<SelectValues>('');
	const [funder, set_funder] = useState<InputValues>('');
	const [contractStart, set_contractStart] = useState<InputValues>('');
	const [contractEnd, set_contractEnd] = useState<InputValues>('');
	const [duration, set_duration] = useState<InputValues>('');
	const [price, set_price] = useState<InputValues>('');
	const [contractNumber, set_contractNumber] = useState<InputValues>('');
	const [billingNumber, set_billingNumber] = useState<InputValues>('');
	const [error, set_error] = useState<{[key: string]: string}>({});

	const [internalId, set_internalId] = useState<InputValues>('');
	const [serial, set_serial] = useState<InputValues>('');
	const [imei, set_imei] = useState<InputValues>('');
	const [imei2, set_imei2] = useState<InputValues>('');
	const [screenSize, set_screenSize] = useState<InputValues>('');
	const [stockage, set_stockage] = useState<SelectValues>(null);
	const [memory, set_memory] = useState<SelectValues>(null);
	const [processor, set_processor] = useState<InputValues>('');
	const [graphicCard, set_graphicCard] = useState<InputValues>('');
	const [network, set_network] = useState<SelectValues>(null);
	const [gpu, set_gpu] = useState<InputValues>('');
	const [keyboard, set_keyboard] = useState<SelectValues>('');
	const [description, set_description] = useState<InputValues>('');
	const [definition, set_definition] = useState<InputValues>('');
	const [compatibility, set_compatibility] = useState<SelectValues[]>([]);
	const [refreshRate, set_refreshRate] = useState<InputValues>('');
	const [responseTime, set_responseTime] = useState<InputValues>('');
	const [ports, set_ports] = useState<SelectValues[]>([]);
	const [connectivity, set_connectivity] = useState<SelectValues[]>([]);
	const [subType, set_subType] = useState<SelectValues>('');
	const [batteryLife, set_batteryLife] = useState<InputValues>('');
	const [anc, set_anc] = useState<InputValues>('');
	const [stand, set_stand] = useState<SelectValues[]>([]);

	const [documents, set_documents] = useState<File[]>([]);

	const [assign, set_assign] = useState<string>();

	const [loadSearchName, set_loadSearchName] = useState(false);
	const [dataSearchName, set_dataSearchName] = useState<SelectData[]>();

	const [saveModal, set_saveModal] = useState(false);
	const [similarList, set_similarList] = useState<string[]>([]);

	const [load, set_load] = useState(false);

	const navigate = useNavigate();
	const params = useParams();
	const TEXTE = LANGUAGE(lang);

	const devicesWithLines = useMemo(() => [...devices, ...mobileLines], [devices, mobileLines]);

	useEffect(() => set_view(params.view || 'home'), [params.view]);

	useEffect(() => {
		if (TIMEOUT)
			clearTimeout(TIMEOUT);
		if (!name)
			return (set_loadSearchName(false));

		set_loadSearchName(true);

		TIMEOUT = setTimeout(() => {
			set_loadSearchName(false);

			API.searchCatalogCategorieByName({search: name.toString()}, user)
			.then((response) => {
				if (!response?.status)
					return set_dataSearchName([]);
				set_dataSearchName(response.data.map((data: ({_id: string, name: string})) => ({
					value:  data._id,
					render: data.name
				})));
			});
		}, 1500);
	}, [name]);

	function addDevice() {
		set_load(true);
		set_saveModal(false);

		const apiData: PutDeviceData = {
			anc,
			gpu,
			name,
			imei,
			imei2,
			ports,
			price,
			stand,
			assign,
			funder,
			serial,
			subType,
			keyboard,
			duration,
			processor,
			internalId,
			definition,
			deviceType,
			screenSize,
			batteryLife,
			graphicCard,
			description,
			refreshRate,
			connectivity,
			purchaseType,
			responseTime,
			billingNumber,
			compatibility,
			contractNumber,
			state:         state?.toString(),
			memory:        memory?.toString(),
			network:       network?.toString(),
			stockage:      stockage?.toString(),
			locationEnd:   contractEnd ? moment(contractEnd, 'DD/MM/YYYY').toDate() : undefined,
			locationStart: contractStart ? moment(contractStart, 'DD/MM/YYYY').toDate() : undefined
		};

		// --- Post Device
		dispatch(postDevicesApi({data: apiData, user}))
		.then((response) => {
			if (!response.payload.status) {
				const notificationData = ft_genNotification(TEXTE, 'error', img_computer, response.payload.error);
				ft_pushNotification(dispatch, notificationId, notificationData);
				return set_load(false);
			}

			let notificationData = ft_genNotification(TEXTE, 'addDeviceSuccess', img_computer, response.payload.name);
			notificationId = ft_pushNotification(dispatch, notificationId, notificationData);

			// --- Upload Documents
			documents.map((document, i) => {
				if (document.size > 2097152)
					return;

				const uploadIndex = documentsUpload.length + i;
				const dispatchData = {index: uploadIndex, dispatch, function: setUploadPercent};
				const uploadFileData = {
					percent:  0,
					filename: document.name,
					size:     document.size,
					id:       response.payload._id
				};

				dispatch(pushUpload(uploadFileData));

				API.uploadDeviceDocument(response.payload._id, document, user, dispatchData)
				.then((responseUpload) => {
					if (!responseUpload || !responseUpload.status)
						return dispatch(setUploadPercent({index: uploadIndex, percent: `error: ${responseUpload?.error || ''}`}));

					notificationData = ft_genNotification(TEXTE, 'fileDownloadDone', img_upload, response.payload.name);
					notificationId = ft_pushNotification(dispatch, notificationId, notificationData);
				});
			});

			set_load(false);
			navigate('/devices/confirm');
		});
	}

	function checkStepIsValid() {
		const newError: {[key: string]: string} = {};

		if (step === 1) {
			if (!name)
				newError.name = 'required';
			if (!purchaseType)
				newError.purchaseType = 'required';
			if (purchaseType === 'lease' && !contractStart)
				newError.contractStart = 'required';
			if (purchaseType === 'lease' && (!duration || duration as number < 1))
				newError.duration = 'required';
		}

		set_error(newError);

		if (Object.keys(newError).length === 0 && step < 4)
			return set_step(step + 1);
		if (step === 4)
			checkBeforeSave();
	}

	function checkBeforeSave() {
		if (!assign)
			return addDevice();

		const result: string[] = [];
		const findCategory = dataSearchName?.find(find => find.render === name);

		devicesWithLines.forEach((deviceData) => {
			if (deviceData.user !== assign)
				return;
			if (deviceData.shopData?.category === findCategory?.value || deviceData.shopData?.name === name || deviceData.name === name)
				result.push(deviceData._id);
		});

		if (result.length === 0)
			return addDevice();

		set_similarList(result);
		return set_saveModal(true);
	}

	function setDeviceData(deviceId: InputValues) {
		const findCategory = dataSearchName?.find(find => find.value === deviceId);

		if (findCategory)
			set_name(findCategory.render as string);

		API.getCatalogCategorieFirstDevice(deviceId as string, user)
		.then((response) => {
			if (!response?.status || !response.data)
				return;

			set_deviceType(response.data.type);

			if (response.data.info)
				set_funder(response.data.info.brand);
		});
	}

	function renderStep1() {
		return (
			<div className={'addDeviceStep1'}>
				<Input
					required
					value={name}
					searchAbsolute
					error={error.name}
					onChange={set_name}
					searchData={dataSearchName}
					searchIsLoad={loadSearchName}
					onClickSearch={setDeviceData}
					title={TEXTE.devices.deviceName}
					placeholder={'ex : MacBook Air M1 13"'}
				/>

				<MultiInputContainer>
					<Select
						required
						value={purchaseType}
						error={error.purchaseType}
						onChange={set_purchaseType}
						title={TEXTE.global.purchaseType}
						data={LOCATION_TYPE(TEXTE)}
					/>
					<Select
						value={deviceType}
						error={error.deviceType}
						onChange={set_deviceType}
						title={TEXTE.global.deviceType}
						data={DEVICE_TYPE(TEXTE)}
					/>
				</MultiInputContainer>

				<MultiInputContainer>
					<Input
						value={funder}
						error={error.funder}
						onChange={set_funder}
						title={TEXTE.global.supplier}
						placeholder={'Apple Pro Services'}
					/>
					<Input
						type={'date'}
						value={contractStart}
						onChange={set_contractStart}
						required={purchaseType === 'lease'}
						error={purchaseType === 'lease' && error.contractStart}
						placeholder={moment().startOf('month').format('DD/MM/YYYY')}
						title={(purchaseType === 'lease') ? TEXTE.global.contractStart : TEXTE.global.purchaseDate}
					/>

				</MultiInputContainer>

				{(purchaseType === 'lease') &&
					<MultiInputContainer>
						<Input
							required
							min={1}
							type={'number'}
							value={duration}
							error={error.duration}
							onChange={set_duration}
							title={TEXTE.global.duration}
							placeholder={`24 ${TEXTE.global.month}`}
							notFocusValue={duration ? `${duration} ${TEXTE.global.month}` : undefined}
						/>
						<Input
							readOnly
							title={TEXTE.global.contractEnd}
							value={(contractStart && duration) ? moment(contractStart, 'DD/MM/YYYY').add(duration, 'month').format('DD/MM/YYYY') : ''}
						/>
					</MultiInputContainer>
				}

				<MultiInputContainer>
					<Input
						min={0}
						value={price}
						type={'number'}
						error={error.price}
						onChange={set_price}
						title={(purchaseType === 'lease') ? TEXTE.global.monthlyPrice : TEXTE.devices.purchasePrice}
						placeholder={ft_formatPrice('24')}
						notFocusValue={price ? ft_formatPrice(price) : undefined}
					/>
					{(purchaseType === 'lease') ?
						<Input
							error={error.contractNumber}
							value={contractNumber}
							onChange={set_contractNumber}
							title={TEXTE.global.contractNumber}
							placeholder={'123456'}
						/>
						:
						<Input
							type={'date'}
							value={contractEnd}
							onChange={set_contractEnd}
							title={TEXTE.global.warrantyEnd}
							placeholder={moment().startOf('month').add(1, 'month').format('DD/MM/YYYY')}
						/>
					}
				</MultiInputContainer>

				{(purchaseType === 'purchase') &&
					<Input
						value={billingNumber}
						placeholder={'123456'}
						onChange={set_billingNumber}
						title={TEXTE.global.billingNumber}
					/>
				}
			</div>
		);
	}

	function renderStep2() {
		return (
			<div>
				<DevicesCharacteristicForm
					notValala
					deviceType={deviceType as string}
					state={state}
					set_state={set_state}
					internalId={internalId}
					set_internalId={set_internalId}
					serial={serial}
					set_serial={set_serial}
					imei={imei}
					set_imei={set_imei}
					imei2={imei2}
					set_imei2={set_imei2}
					screenSize={screenSize}
					set_screenSize={set_screenSize}
					stockage={stockage}
					set_stockage={set_stockage}
					memory={memory}
					set_memory={set_memory}
					processor={processor}
					set_processor={set_processor}
					graphicCard={graphicCard}
					set_graphicCard={set_graphicCard}
					network={network}
					set_network={set_network}
					gpu={gpu}
					set_gpu={set_gpu}
					keyboard={keyboard}
					set_keyboard={set_keyboard}
					description={description}
					set_description={set_description}
					definition={definition}
					set_definition={set_definition}
					compatibility={compatibility}
					set_compatibility={set_compatibility}
					refreshRate={refreshRate}
					set_refreshRate={set_refreshRate}
					responseTime={responseTime}
					set_responseTime={set_responseTime}
					ports={ports}
					set_ports={set_ports}
					connectivity={connectivity}
					set_connectivity={set_connectivity}
					subType={subType}
					set_subType={set_subType}
					batteryLife={batteryLife}
					set_batteryLife={set_batteryLife}
					anc={anc}
					set_anc={set_anc}
					stand={stand}
					set_stand={set_stand}
				/>
			</div>
		);
	}

	function renderStep3() {
		return <DeviceDocuments documents={documents} setDocument={set_documents} />;
	}

	function renderStep4() {
		return (
			<div>
				<ModalAssign
					notModal
					actualId={assign ? [assign] : []}
					onChange={value => set_assign(assign === value?._id ? '' : value?._id)}
				/>
			</div>
		);
	}

	function renderButtonContainer() {
		return (
			<ButtonStickyContainer>
				<Button
					fullWidth
					disabled={load}
					type={'tertiary-gray'}
					onClick={() => (step === 1 ? navigate('/devices/add') : set_step(step - 1))}
				>
					{step === 1 ? TEXTE.global.cancel : TEXTE.global.previous}
				</Button>

				<Button
					fullWidth
					isLoad={load}
					onClick={checkStepIsValid}
				>
					{step === 4 ? TEXTE.global.validAndSave : TEXTE.global.next}
				</Button>
			</ButtonStickyContainer>
		);
	}

	function renderSaveModal() {
		const render: React.ReactElement[] = [];

		similarList.forEach((id) => {
			const deviceData = devicesWithLines.find(find => find._id === id);

			if (deviceData)
				render.push(<DeviceCard device={deviceData} />);
		});

		return (
			<Modal
				size={798}
				confirmLoad={load}
				confirmButton={addDevice}
				header={<IconModalSave />}
				confirmButtonText={TEXTE.global.confirm}
				cancelButton={() => set_saveModal(false)}
				cancelButtonText={TEXTE.users.modal.cancelSelection}
			>
				<span className={'modalTitle'}>
					{TEXTE.devices.similarDevice}
				</span>

				<span>{TEXTE.devices.similarDeviceText}</span>
				<span className={'weight-600'}>{TEXTE.devices.selectAffectDevice}</span>

				<br />
				{render}
			</Modal>
		);
	}

	if (view === 'import')
		return <DevicesImport />;

	if (view === 'home') {
		return (
			<div className={'addCardMainContainer'}>
				<AddCard
					icon={img_computer}
					iconColor={'#ffffff'}
					image={img_backgroundAddManually}
					onClick={() => navigate('/devices/add/manually')}
					title={TEXTE.devices.addDeviceManually}
					text={TEXTE.devices.addDeviceManuallyText}
				/>
				<AddCard
					icon={img_fileDownload}
					image={img_backgroundAddImport}
					backgroundColorIcon={'#878BE4'}
					onClick={() => navigate('/devices/add/import')}
					title={TEXTE.devices.addDeviceImport}
					text={TEXTE.devices.addDeviceImportText}
				/>
			</div>
		);
	}

	return (
		<div className={'globalDataContainer'}>
			<div className={'globalAddHeader'}>
				<Icon
					icon={img_computer}
					iconColor={'#000000'}
				/>
				<div className={'globalAddHeaderText'}>
					<span>{TEXTE.devices.addDevice}</span>
					<span>{TEXTE.devices.setDeviceData}</span>
				</div>
			</div>

			<div className={'globalAddContainer'}>
				<Tabs
					step
					actual={step}
					onChange={val => set_step(val as number)}
					data={[
						{value: 1, render: TEXTE.devices.aboutDevice},
						{value: 2, render: TEXTE.devices.characteristic},
						{value: 3, render: TEXTE.devices.deviceDocuments},
						{value: 4, render: TEXTE.devices.assignDevice}
					]}
				/>

				{step === 1 && renderStep1()}
				{step === 2 && renderStep2()}
				{step === 3 && renderStep3()}
				{step === 4 && renderStep4()}
			</div>

			{renderButtonContainer()}

			{saveModal && renderSaveModal()}
		</div>
	);
}

export default DeviceAdd;